export const CustomSpinner = ({ size = 'xl', color = '#06c' }) => {
	const sizePx =
		{
			sm: 20,
			md: 30,
			lg: 50,
			xl: 90,
		}[size] ?? 90;

	const strokeWidth = 3;
	const radius = (sizePx - strokeWidth) / 2;
	const circumference = 2 * Math.PI * radius;

	return (
		<svg
			width={sizePx}
			height={sizePx}
			viewBox={`0 0 ${sizePx} ${sizePx}`}
			className="custom-spinner-svg"
			style={{ animation: 'rotate 1s linear infinite' }}
		>
			<circle
				cx={sizePx / 2}
				cy={sizePx / 2}
				r={radius}
				fill="none"
				stroke={color}
				strokeWidth={strokeWidth}
				strokeLinecap="round"
				strokeDasharray={`${circumference * 0.25} ${circumference}`}
				strokeDashoffset="0"
				style={{ animation: 'dash 1.5s ease-in-out infinite' }}
			/>
			<style>
				{`
          @keyframes rotate {
            100% { transform: rotate(360deg); }
          }
          @keyframes dash {
            0% {
              stroke-dasharray: 1, ${circumference};
              stroke-dashoffset: 0;
            }
            50% {
              stroke-dasharray: ${circumference * 0.5}, ${circumference};
              stroke-dashoffset: -${circumference * 0.25};
            }
            100% {
              stroke-dasharray: 1, ${circumference};
              stroke-dashoffset: -${circumference};
            }
          }
        `}
			</style>
		</svg>
	);
};
